import { render, staticRenderFns } from "./GuidelineMenu.vue?vue&type=template&id=07cd9c57"
import script from "./GuidelineMenu.vue?vue&type=script&lang=js"
export * from "./GuidelineMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports